<template>
    <div class="filter__wrap" :class="{'filter__wrap--two-rows': twoRows}">
        <div class="filter__field filter__field--check">
            <span class="filter__select-label">{{ $t('general.select-label') }}</span>
            <v-tooltip bottom v-for="key in selectKeys" :key="key">
                <template v-slot:activator="{ on, attrs }">
                    <span class="filter__tip" v-bind="attrs" v-on="on">
                        <v-checkbox
                            :label="$t(`general.select-${key.replace(/_/g, '-')}`)"
                            :input-value="selectOptions.includes(key)"
                            @change="$emit('select-options', toggle(selectOptions, key))"
                            hide-details
                            dense
                            class="mt-0 pt-0"
                        ></v-checkbox>
                    </span>
                </template>
                <span>{{ $t(`general.tt_filter_${key}`) }}</span>
            </v-tooltip>
        </div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    small
                    color="primary"
                    @click="$emit('on-choose-today')"
                    class="elevation-1"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('general.today') }}
                </v-btn>
            </template>
            <span>{{ $t('general.tt_filter_today') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    small
                    color="primary"
                    @click="$emit('on-choose-yesterday')"
                    class="elevation-1"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('general.yesterday') }}
                </v-btn>
            </template>
            <span>{{ $t('general.tt_filter_yesterday') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    small
                    color="primary"
                    @click="$emit('on-choose-weekly')"
                    class="elevation-1"
                    v-bind="attrs"
                    v-on="on">
                    {{ $t('general.weekly') }}
                </v-btn>
            </template>
            <span>{{ $t('general.tt_filter_weekly') }}</span>
        </v-tooltip>
        <div class="filter__export">
        <download-excel
            :data="selected"
            :fields="excelFields"
            :name="todayDate"
        >
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span class="filter__tip" v-bind="attrs" v-on="on">
                        <v-btn
                            small
                            color="primary"
                            :disabled="selected.length < 1"
                            class="elevation-1">
                            <v-icon left small>mdi-download</v-icon>
                            {{ $t('general.excel-export') }}
                        </v-btn>
                    </span>
                </template>
                <span>{{ $t('general.tt_filter_excel') }}</span>
            </v-tooltip>
        </download-excel>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span class="filter__tip" v-bind="attrs" v-on="on">
                    <v-btn
                        small
                        color="primary"
                        @click="onPrintItems"
                        :disabled="isBlockBtnPrint"
                        :loading="loading_print_items"
                        class="elevation-1">
                        <v-icon left small>mdi-printer</v-icon>
                        {{ $t('general.print-labels') }}
                    </v-btn>
                </span>
            </template>
            <span>{{ $t('general.tt_filter_labels_print') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span class="filter__tip" v-bind="attrs" v-on="on">
                    <v-btn
                        small
                        color="primary"
                        @click="onMailItems"
                        :disabled="isBlockBtnPrint"
                        class="elevation-1">
                        <v-icon left small>mdi-email-outline</v-icon>
                        {{ $t('general.mail-action') }}
                    </v-btn>
                </span>
            </template>
            <span>{{ $t('general.tt_filter_labels_mail') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span class="filter__tip" v-bind="attrs" v-on="on">
                    <v-btn
                        small
                        color="error"
                        @click="onDeleteItems"
                        :disabled="isBlockBtnPrint"
                        class="elevation-1">
                        <v-icon left small>mdi-delete</v-icon>
                        {{ $t('general.delete-action') }}
                    </v-btn>
                </span>
            </template>
            <span>{{ $t('general.tt_filter_labels_delete') }}</span>
        </v-tooltip>
        </div>
        <delete-selected-dialog v-model="dialogDeleteSelectedItems" :selected="selected" @done="$emit('init-items')"/>
    </div>
</template>

<script>
//import Order from "../../../models/Order";

import {ORDER_EXCEL_FIELDS} from "@/utils/orderExcel";
import {SELECT_OPTIONS, toggleOption} from "@/utils/orderSelection";
import DeleteSelectedDialog from "./DeleteSelectedDialog";

export default {
    name: "OrderFilter",
    props: {
        selected: {type: Array, default: () => []},
        selectOptions: {type: Array, default: () => []},
        loading_print_items: {type: Boolean, default: false},
    },
    components: {DeleteSelectedDialog},
    data: () => ({
        selectKeys: SELECT_OPTIONS,
        twoRows: false,
        barWidth: 0,
        dialogDeleteSelectedItems: false,
        excelFields: ORDER_EXCEL_FIELDS,
        todayDate: `${new Date().toString()}.xls`
    }),
    computed: {
        isBlockBtnPrint() {
            return !this.selected.length
        },
    },
    mounted() {
        // without ResizeObserver the bar simply stays on one row
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => this.updateRows());
            this.resizeObserver.observe(this.$el);
        }
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    methods: {
        // Excel + labels move to a second row only when the bar itself is too
        // narrow (window size, side navigation, label lengths all count)
        async updateRows() {
            const width = this.$el.clientWidth;
            if (width === this.barWidth) {
                return;
            }
            this.barWidth = width;
            this.twoRows = false;
            await this.$nextTick();
            const first = this.$el.firstElementChild;
            const actions = this.$el.querySelector('.filter__export');
            this.twoRows = Boolean(first && actions) && actions.offsetTop > first.offsetTop;
        },
        toggle: toggleOption,
        onDeleteItems() {
            this.dialogDeleteSelectedItems = true
        },
        onPrintItems() {
            this.$emit('print-labels', this.selected)
        },
        onMailItems() {
            this.$emit('mail-labels', this.selected)
        },
    },
}
</script>

<style scoped lang="scss">

.filter__wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;

    .filter__field {
        background: #fff;
        padding: 11px 10px;
        border-radius: 5px;
        max-height: 65px;
    }

    // same height as the (small) buttons, labels on one line
    .filter__field--check {
        display: flex;
        align-items: center;
        gap: 12px;
        height: 28px;
        padding: 0 12px;
        white-space: nowrap;
    }

    // wrapper that carries the hover listeners; stays a single flex item
    .filter__tip {
        display: inline-flex;
    }

    .filter__select-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
    }

    .filter__export {
        display: flex;
        gap: 12px;
    }

    // too narrow for one row: Excel and the action buttons move to a second row together
    &.filter__wrap--two-rows {
        .filter__export {
            flex-basis: 100%;
        }
    }
}


</style>
